import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const playbookNameDropdown = createAsyncThunk(
  "NameDropdown",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPost(urls?.playbookNameDropdown, arg);      
      return response;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

export const playbookNameDropdownSlice = createSlice({
  name: "NameDropdown",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    playbookNameDropdownReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [playbookNameDropdown.pending]: (state) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
    },
    [playbookNameDropdown.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.data = payload;
      state.error = null;
    },
    [playbookNameDropdown.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.data = false;
    },
  },
});



export const { playbookNameDropdownReset } = playbookNameDropdownSlice.actions;

